module.exports = "https://static.wagwalking.com/_next/static/images/walk-3-9e50707d228e68362330ad54f1ae59da.svg";